import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { ClientesListagemComponent } from './clientes-listagem/clientes-listagem.component';
import { ClientesEditarComponent } from './clientes-editar/clientes-editar.component';
import { ClientesDetalhesComponent } from './clientes-detalhes/clientes-detalhes.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ConfirmationService } from 'primeng/api';
import { ClientesRoutingModule } from './clientes-routing.module';
import { ClientesAdicionarComponent } from './clientes-adicionar/clientes-adicionar.component';
import { FieldsetModule } from 'primeng/fieldset';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { ToolbarSearchComponent } from '../../shared/toolbarSearch/toolbarSearch.component';

@NgModule({
  declarations: [
    ClientesListagemComponent,
    ClientesEditarComponent,
    ClientesDetalhesComponent,
    ClientesAdicionarComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    ConfirmDialogModule,
    DropdownModule,
    TooltipModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ClientesRoutingModule,
    FieldsetModule,
    ProgressSpinnerModule,
    SpinnerServiceComponent,
    ToolbarSearchComponent
  ],
  providers: [provideNgxMask(), ConfirmationService],
  exports: [ClientesListagemComponent]
})
export class ClientesModule { }
